<template>
    <v-tooltip
        :disabled="!tooltip"
        right
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                small
                :large="large"
                icon
                :class="classe"
                :color="color"
                :loading="loading"
                :disabled="disabled"
                @click="press"
            >
                <v-icon>{{ icon }}</v-icon>
            </v-btn>
        </template>
        <span v-if="html" style="white-space: pre-wrap" v-html="tooltip.replace(/\n/g, '<br>')"></span>
        <span v-else>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'WBtnIcon',
    props: {
        loading: Boolean,
        disabled: Boolean,
        large: Boolean,
        html: Boolean,
        color: String,
        icon: String,
        tooltip: String,
        classe: String,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>